/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2024-08-26 11:36:40
 */
import { createApp } from 'vue'
import 'lib-flexible'
import App from './App.vue'
import { Loading, Toast } from 'vant'

const app = createApp(App)
app.use(Loading)
app.use(Toast)

app.mount('#app')
